import { useFeature } from '@src/globalStore/featureStore';
import featureNames from '@src/utils/featureToggle/constants';
import { Alert } from 'antd';
import moment from 'moment';
import React from 'react';

const ThrottledDataWarning = () => {
  const gwThrottlingStartDate = useFeature(featureNames.GW_THROTTLING_START_DATE);
  const throttlingDate = moment(gwThrottlingStartDate);

  return throttlingDate.isValid() ? (
    <div
      style={{
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Alert
        style={{ fontSize: 12 }}
        message={`Collection throttling is applied at ${throttlingDate.format('YYYY-MM-DD HH:mm')} since the observed traffic is more than the allowed PCP limit`}
        type="warning"
        showIcon
        banner
      />
    </div>
  ) : null;
};

export default ThrottledDataWarning;
